import { Component } from 'react';
import CollapsibleDefault from './CollapsibleDefault';
import { apiGetFileP, apiGetP, apiPostNoBodyA, apiPostNoBodyP, apiPrefix } from '../../GanjiTools';
import Theme from '../theme/Theme';
import { Button, CheckBox, Tooltip } from 'devextreme-react';
import Badge from '../utils/Badge';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import Inline from '../Inline';

class ViewDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [{ url: '' }],
            selectedDocs: [],
        }
    }

    static async deleteAuxFileA(table, rowId) {
        if (!confirm('واقعاً حذف شود؟'))
            return;

        let res = await apiPostNoBodyA(`/api/parssaman/deleteAuxFile/${table}/${rowId}`);

        res ??= { error: 'No response.' };

        if (res.error?.length > 0)
            throw (res.error);
    }

    static renderItem({ doc, table, tableRowId, width, height, index }, component) {
        return (
            <div style={{ padding: '10px', overflow: 'hidden', height: '100%', position: 'relative' }}
                id={`aux_${table}_${tableRowId}_${doc.id ?? 0}_${index ?? 0}`}
                key={`aux_${table}_${tableRowId}_${doc.id ?? 0}_${index ?? 0}`}
            >
                <a href={apiPrefix + doc.url}
                    style={{ display: 'flex', borderRadius: '10px', backgroundColor: Theme.col0('lightgray'), padding: '10px' }}
                >
                    {doc.imageUrl?.length > 0
                        ?
                        <img src={apiPrefix + doc.imageUrl}
                            width={width ?? '200px'} height={height ?? '280px'}
                            style={{ objectFit: 'contain' }}
                            alt={doc.fileName + ' ' + (doc.comment ?? '')}
                        />
                        :
                        <div
                            style={{
                                width: width ?? '200px', height: height ?? '280px',
                                display: 'flex', alignItems: 'center',
                                color: 'blue', textWrap: 'auto'
                            }}
                        >
                            {doc.fileName}
                        </div>
                    }
                </a>
                <FontAwesomeIcon icon='trash-can' fontSize='1.5rem' hint='حذف'
                    style={{ color: 'red', position: 'absolute', bottom: '1.5rem', right: '1.5rem', cursor: 'pointer' }}
                    onClick={() => ViewDocuments.deleteAuxFileA(table, tableRowId).then(() => component?.loadData?.()).catch(window.notif)}
                />
                <div style={{ position: 'absolute', bottom: '1.5rem', left: '1.5rem', cursor: 'pointer' }}>
                    <CheckBox fontSize='1.5rem' hint='انتخاب' rtlEnabled
                        value={component.state.selectedDocs.includes(doc.id)}
                        onValueChanged={e => {
                            e.value
                                ? component.state.selectedDocs.push(doc.id)
                                : component.state.selectedDocs = component.state.selectedDocs.filter(x => x !== doc.id) ?? [];

                            component.forceUpdate();
                        }}
                    />
                </div>

            </div>
        );
    }

    renderBody = () => (
        <div style={{
            width: '100%', height: '100%', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'flex-start',
            borderRadius: '10px', backgroundColor: 'transparent', //Theme.col1('gray')
        }}
        >
            {this.state.list?.filter(this.props.filter ?? (x => x.rowId > 0))
                .map((doc, ix) => ViewDocuments.renderItem({
                    doc,
                    table: this.props.table,
                    tableRowId: this.props.rowId,
                    width: this.props.itemWidth,
                    height: this.props.itemHeight,
                    index: ix
                }, this))}
        </div>
    );

    loadData = () => {
        if (!(this.props.rowId > 0) || !this.props.table)
            return;

        apiGetP(`/api/parssaman/auxFiles/${this.props.table}/${this.props.rowId}`)
            .then(res => {
                let { list, error } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ list });
                console.log(this.props.table, ' row#', this.props.rowId, ' docs:', list);
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps?.rowId !== this.props.rowId || prevProps?.table !== this.props.table) {
            console.log('ViewDocuments: detected prop change, reloading list for', this.props.table, this.props.rowId);
            this.setState({ list: [] }, this.loadData);
        }
    }

    componentDidMount() {
        this.loadData();
    }

    renderBatchDownloadButton = () => {
        return (
            <Button icon='download' hint='دانلود اسناد انتخاب شده'
                onClick={() => {
                    this.setState({ downloading: true });
                    apiGetFileP(`/api/parssaman/auxFilesAsPdf?selectedIds=${this.state.selectedDocs.join(',')}`, 'docs.pdf')
                        .then()
                        .catch(window.notif)
                        .finally(() => this.setState({ downloading: false }));
                }}
            />
        );
    }

    render() {
        const badge = this.state.list?.filter(this.props.filter ?? (x => x.rowId > 0))?.length ?? 0;
        return (
            <div style={{
                width: this.props.width, height: '100%'
            }}>
                {this.props.noCollapsible
                    ?
                    this.renderBody()
                    :
                    <CollapsibleDefault width={this.props.width}
                        title={
                            <Inline spacing='1em'>
                                <CheckBox fontSize='1.5rem' hint=' انتخاب همه' rtlEnabled
                                    value={this.state.selectedDocs?.length == 0 ? false
                                        : this.state.selectedDocs?.length === this.state.list?.length ? true
                                            : undefined}

                                    onValueChanged={e => this.setState({
                                        selectedDocs: e.value === true ? (this.state.list?.map(x => x.id) ?? [])
                                            : e.value === false ? []
                                                : this.state.selectedDocs
                                    })}
                                />
                                <div>اسناد</div>
                                {this.state.downloading && <FontAwesomeIcon icon='spinner' spin fontSize='1.3rem' hint='درحال دانلود...' />}
                                {!this.state.downloading && this.state.selectedDocs.length > 0 && this.renderBatchDownloadButton()}
                            </Inline>
                        }
                        summary={badge > 0 && <Badge text={badge} size={24} style={{ opacity: '50%' }} />}
                    >
                        {this.renderBody()}
                    </CollapsibleDefault>
                }

                {this.state.list?.map((doc, ix) =>
                    <Tooltip target={`#aux_${this.props.table}_${this.props.rowId}_${doc?.id ?? 0}_${ix ?? 0}`}
                        key={ix}
                        rtlEnabled
                        showEvent={{ name: 'mouseenter', delay: 800 }} hideEvent='mouseleave'
                        hideOnOutsideClick={false}
                    >
                        دسته:
                        {doc.cat}
                        <br />
                        نام فایل:
                        {doc.fileName}
                        <br />
                        توضیح:
                        {doc.comment}
                    </Tooltip >
                )}
            </div>
        );
    }
}

export default ViewDocuments;
